import { CircularProgress } from '@mui/material';

interface Props {
    title: string;
    isFilled?: boolean;
    disabled?: boolean;
    loading?: boolean;
    fullWidth?: boolean;
    variant?: 'default' | 'delete';
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}
function CustomButton({ isFilled = true, disabled = false, loading = false, fullWidth = false, variant = 'default', onClick, title }: Props) {

    const baseClasses = 'font-semibold px-4 py-2 rounded-md flex items-center justify-center relative transition-colors';

    let variantClasses: string;
    if (variant === 'delete') {
        variantClasses = 'border border-red-500 text-red-500 hover:bg-red-50';
    } else if (isFilled) {
        variantClasses = 'bg-primary text-text-buttonContrast';
    } else {
        variantClasses = 'border border-primary text-primary';
    }
    
    if (disabled) {
        // Filled: white text (with opacity) on primary bg stays readable
        // Outlined: muted primary text
        variantClasses = isFilled
            ? 'bg-primary text-white/60 cursor-not-allowed'
            : 'border border-primary text-primary/40 cursor-not-allowed';
    }

    const widthClass = fullWidth ? 'w-full' : 'w-fit';

    return (
        <button
            className={`${baseClasses} ${variantClasses} ${widthClass}`}
            // A loading button cannot be clicked again: a second click while
            // the first save is still running would send it twice. Every
            // caller passing `loading` gets this, rather than each one having
            // to remember to add its saving flag to `disabled` (F, PO 2026-10-11).
            disabled={disabled || loading}
            aria-busy={loading || undefined}
            onClick={onClick}
        >
            <span className={loading ? 'invisible' : 'visible'}>{title}</span>
            {loading && (
                <div className={'absolute inset-0 flex items-center justify-center'}>
                    <CircularProgress size={20} sx={{ color: 'inherit' }} />
                </div>
            )}
        </button>
    );
}

export default CustomButton;
